<template lang="html">
	<div class="rs-customer-view">
		<div class="row">
			<div class="col">
				<h2>Persönliche Daten</h2>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<b-field 
					label="Anrede *" 
					:type="form.customerGender ? '' : 'is-danger'">
					<b-select 
						v-model="form.customerGender" 
						expanded 
						required> 
						<option 
							v-for="gender in genders" 
							:key="gender.id" 
							:value="gender">
							{{ gender.name }}
						</option>
					</b-select>
				</b-field>
			</div>
			<div class="col-md-6">
				<b-field 
					label="Vorname *" 
					:type="form.customerFirstName ? '' : 'is-danger'">
					<b-input 
						type="text" 
						v-model="form.customerFirstName" 
						required/>
				</b-field>
			</div>
			<div class="col-md-6">
				<b-field 
					label="Nachname *" 
					:type="form.customerLastName ? '' : 'is-danger'">
					<b-input 
						type="text" 
						v-model="form.customerLastName" 
						required/>
				</b-field>
			</div>
			<div class="col-md-6">
				<b-field 
					label="Straße *" 
					:type="form.customerStreet ? '' : 'is-danger'">
					<b-input 
						type="text" 
						v-model="form.customerStreet" 
						required/>
				</b-field>
			</div>
			<div class="col-md-6">
				<b-field 
					label="PLZ *" 
					:type="form.customerZipCode ? '' : 'is-danger'">
					<b-input 
						type="text" 
						v-model="form.customerZipCode" 
						required/>
				</b-field>
			</div>
			<div class="col-md-6">
				<b-field 
					label="Ort *" 
					:type="form.customerCity ? '' : 'is-danger'">
					<b-input 
						type="text" 
						v-model="form.customerCity" 
						required/>
				</b-field>
			</div>
			<div class="col-md-6">
				<b-field 
					label="Land *" 
					:type="form.customerCountry ? '' : 'is-danger'">
					<b-select 
						v-model="form.customerCountry" 
						expanded 
						required> 
						<option 
							v-for="(value, key) in countries" 
							:key="key" 
							:value="key">
							{{ value }}
						</option>
					</b-select>
				</b-field>
			</div>
			<div class="col-md-6">
				<b-field 
					label="E-Mail *" 
					:type="form.customerEmail ? '' : 'is-danger'">
					<b-input 
						type="email" 
						v-model="form.customerEmail" 
						required/>
				</b-field>
			</div>
			<div class="col-md-6">
				<b-field 
					label="Handynummer *" 
					:type="form.customerMobile ? '' : 'is-danger'">
					<b-input 
						type="text" 
						v-model="form.customerMobile" 
						required/>
				</b-field>
			</div>
			<div class="col-md-6">
				<b-field label="Telefon">
					<b-input 
						type="text" 
						v-model="form.customerPhone" />
				</b-field>
			</div>
			<div class="col-md-12">
				<b-field label="Bemerkung">
					<b-input 
						type="textarea" 
						v-model="form.customerNote" />
				</b-field>
			</div>
		</div>
		<br>
		<div class="text-right">
			<div class="buttons has-addons is-right">
				<button 
					class="button is-secondary" 
					@click="back">Zurück</button>
				<button 
					class="button is-primary" 
					@click="next" 
					:disabled="!fieldsValid">Weiter</button>
			</div>
		</div>
	</div>
</template>

<script>
import InputText from '../components/InputText.vue'
import InputArea from '../components/InputArea.vue'
import InputSelect from '../components/InputSelect.vue'
import countries from '../services/countries.json'

export default {
	name: 'CustomerView',
	components: {
		InputArea,
		InputText,
		InputSelect
	},
	data() {
		return {
			genders: [
				{
					id: 'm',
					name: 'Herr'
				},
				{
					id: 'f',
					name: 'Frau'
				}
			],
			countries,
			form: Object.assign({}, this.$store.state.order.customer)
		}
	},
	computed: {
		fieldsValid() {
			const f = this.form
			return (
				f.customerGender &&
				f.customerFirstName &&
				f.customerLastName &&
				f.customerStreet &&
				f.customerZipCode &&
				f.customerCity &&
				f.customerCountry &&
				f.customerMobile &&
				validateEmail(f.customerEmail)
			)
		}
	},
	methods: {
		back() {
			this.$store.commit('order/SET_CUSTOMER', this.form)
			this.$emit('previous')
		},
		next() {
			this.$store.commit('order/SET_CUSTOMER', this.form)
			this.$emit('next')
		}
	}
}
function validateEmail(email) {
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return re.test(String(email).toLowerCase())
}
</script>

<style lang="css">
.form-group.is-invalid.dirty input{
        border-color: #dc3545;
}
.rs-customer-view .field{
    margin-bottom: .5em;
}
</style>
